import React from "react";
import { Navbar, Col, Container, Nav, Row } from "react-bootstrap";
import { useRef, useEffect } from "react";
import logout from "../Auth/Logout";
import { Link } from "react-router-dom";
import { useNavUI } from "../Context/NavUIContext";

export default (states) => {
    const { isAuthenticated, setIsAuthenticated, l, toggleLanguage, language } = states; // keep these from your existing context/props

    // UI state from NavUIContext
    const { state, dispatch } = useNavUI();
    const { menuOpen, adminOpen, expertiseOpen } = state;

    const setOpen = (key, value) => dispatch({ type: "set", key, value });
    const toggle = (key) => dispatch({ type: "toggle", key });

    // Extract the first part of the pathname (e.g., "products" from "/products/ProductName")
    const pathParts = window.location.pathname.split("/").filter(part => part);
    const location = pathParts[0] || "";
    
    // Map detailed pages to their edit page equivalents
    const getEditPageType = (loc) => {
        if (loc === "products") return "products";
        if (loc === "references") return "references";
        return loc;
    };
    
    const editPageType = getEditPageType(location);
    
    // Extract section for expertise pages (e.g., "rust-protection" from "/expertise/rust-protection")
    const getSection = () => {
        if (location === "expertise" && pathParts.length > 1) {
            return pathParts[1];
        }
        return null;
    };
    
    const section = getSection();

    const mainMenuRef = useRef();

    useEffect(() => {
        if (!menuOpen) return;

        const handleClickOutside = (event) => {
            if (mainMenuRef.current && !mainMenuRef.current.contains(event.target)) {
                setOpen("menuOpen", false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <>
            <Navbar className="py-1">
                <Row className="m-0 p-0 w-100  align-items-center">
                    <Col className="d-flex align-items-center nav-wrap">
                        <Navbar.Brand href="/" className="d-flex align-items-center">
                            <Container className="p-0 d-flex align-items-center">
                                <img
                                    style={{ width: "80px", height: "80px" }}
                                    src='/images/logo_symbol.png'
                                    alt="Logo"
                                />
                            </Container>
                        </Navbar.Brand>
                    </Col>

                    {isAuthenticated ? (
                        <Col className="text-center">
                            <i
                                className="fa fa-cog"
                                style={{ fontSize: "45px", cursor: "pointer" }}
                                onClick={() => {
                                    // toggle admin panel, ensure main menu is closed
                                    toggle("adminOpen");
                                    setOpen("menuOpen", false);
                                }}
                                aria-controls="admin-dropdown-menu"
                                aria-expanded={adminOpen}
                                aria-label="Admin"
                                role="button"
                            />
                        </Col>
                    ) : (
                        <></>
                    )}

                    <Col className="justify-content-end d-flex align-items-center nav-wrap">
                        <button
                            className={`hamburger ${menuOpen ? "is-active" : ""}`}
                            aria-label={menuOpen ? "Close menu" : "Open menu"}
                            aria-expanded={menuOpen}
                            aria-controls="main-dropdown-menu"
                            onClick={() => {
                                // toggle main menu, ensure admin is closed
                                toggle("menuOpen");
                                setOpen("adminOpen", false);
                            }}
                        >
                            <span className="bar" />
                        </button>
                    </Col>
                </Row>

                {/* Main menu panel */}
                <div
                    ref={mainMenuRef}
                    id="main-dropdown-menu"
                    className={`dropdown-panel ${menuOpen ? "show" : ""}`}
                    role="menu"
                    aria-hidden={!menuOpen}
                >
                    <Nav className="flex-column" onSelect={() => setOpen("menuOpen", false)}>
                        <Nav.Link href="/" as="a" role="menuitem" style={{ fontWeight: "bold" }}>
                            {l('Hem', 'Home')}
                        </Nav.Link>
                        <Nav.Item>
                            <Nav.Link
                                as="a"
                                role="menuitem"
                                style={{ fontWeight: "bold" }}
                                onClick={() => setOpen("aboutDropdownOpen", !state.aboutDropdownOpen)}
                                aria-expanded={!!state.aboutDropdownOpen}
                                aria-controls="about-dropdown"
                            >
                                {l('Om Introteknik', 'About Introteknik')}
                                <span style={{ float: "right" }}>
                                    <i className={`fa fa-chevron-${state.aboutDropdownOpen ? "up" : "down"}`}></i>
                                </span>
                            </Nav.Link>
                            <div
                                id="about-dropdown"
                                style={{
                                    maxHeight: state.aboutDropdownOpen ? "200px" : "0",
                                    overflow: "hidden",
                                    transition: "max-height 0.3s cubic-bezier(0.4,0,0.2,1)",
                                    paddingLeft: state.aboutDropdownOpen ? "1.5rem" : "1.5rem",
                                }}
                                aria-hidden={!state.aboutDropdownOpen}
                            >
                                {state.aboutDropdownOpen && (
                                    <Nav className="flex-column">
                                        <Nav.Link
                                            href="/contact"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Kontakt', 'Contact')}
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/about"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Vision', 'Vision')}
                                        </Nav.Link>
                                    </Nav>
                                )}
                            </div>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link
                                as="a"
                                role="menuitem"
                                style={{ fontWeight: "bold" }}
                                onClick={() => setOpen("expertiseOpen", !state.expertiseOpen)}
                                aria-expanded={!!state.expertiseOpen}
                                aria-controls="about-dropdown"
                            >
                                {l('Verksamhetsområden', 'Markets')}
                                <span style={{ float: "right" }}>
                                    <i className={`fa fa-chevron-${state.expertiseOpen ? "up" : "down"}`}></i>
                                </span>
                            </Nav.Link>
                            <div
                                id="about-dropdown"
                                style={{
                                    maxHeight: state.expertiseOpen ? "200px" : "0",
                                    overflow: "hidden",
                                    transition: "max-height 0.3s cubic-bezier(0.4,0,0.2,1)",
                                    paddingLeft: state.expertiseOpen ? "1.5rem" : "1.5rem",
                                }}
                                aria-hidden={!state.expertiseOpen}
                            >
                                {state.expertiseOpen && (
                                    <Nav className="flex-column">
                                        <Nav.Link
                                            href="/expertise/rust-protection"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Rostskydd', 'Rust protection')}
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/expertise/roof-painting"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Takmålning', 'Roof painting')}
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/expertise/cultural-heritage"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Kulturhistoriska objekt', 'Cultural heritage objects')}
                                        </Nav.Link>
                                    </Nav>
                                )}
                            </div>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link
                                as="a"
                                role="menuitem"
                                style={{ fontWeight: "bold" }}
                                onClick={() => setOpen("referenceOpen", !state.referenceOpen)}
                                aria-expanded={!!state.referenceOpen}
                                aria-controls="about-dropdown"
                            >
                                {l('Referenser', 'References')}
                                <span style={{ float: "right" }}>
                                    <i className={`fa fa-chevron-${state.referenceOpen ? "up" : "down"}`}></i>
                                </span>
                            </Nav.Link>
                            <div
                                id="about-dropdown"
                                style={{
                                    maxHeight: state.referenceOpen ? "200px" : "0",
                                    overflow: "hidden",
                                    transition: "max-height 0.3s cubic-bezier(0.4,0,0.2,1)",
                                    paddingLeft: state.referenceOpen ? "1.5rem" : "1.5rem",
                                }}
                                aria-hidden={!state.referenceOpen}
                            >
                                {state.referenceOpen && (
                                    <Nav className="flex-column">
                                        <Nav.Link
                                            href="/references"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Kundutlåtanden', 'Customer statements')}
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/reports"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Rapporter', 'Reports')}
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/tests"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Tester', 'Tests')}
                                        </Nav.Link>
                                    </Nav>
                                )}
                            </div>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link
                                as="a"
                                role="menuitem"
                                style={{ fontWeight: "bold" }}
                                onClick={() => setOpen("productOpen", !state.productOpen)}
                                aria-expanded={!!state.productOpen}
                                aria-controls="about-dropdown"
                            >
                                {l('Produkter', 'Products')}
                                <span style={{ float: "right" }}>
                                    <i className={`fa fa-chevron-${state.productOpen ? "up" : "down"}`}></i>
                                </span>
                            </Nav.Link>
                            <div
                                id="about-dropdown"
                                style={{
                                    maxHeight: state.productOpen ? "200px" : "0",
                                    overflow: "hidden",
                                    transition: "max-height 0.3s cubic-bezier(0.4,0,0.2,1)",
                                    paddingLeft: state.productOpen ? "1.5rem" : "1.5rem",
                                }}
                                aria-hidden={!state.productOpen}
                            >
                                {state.productOpen && (
                                    <Nav className="flex-column">
                                        <Nav.Link
                                            href="/products"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Produktlista', 'Product list')}
                                        </Nav.Link>
                                        <Nav.Link
                                            href="/sheets"
                                            as="a"
                                            role="menuitem"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {l('Data/Säkerhetsblad', 'Data and safety sheets')}
                                        </Nav.Link>
                                    </Nav>
                                )}
                            </div>
                        </Nav.Item>

                        <Nav.Link href="/retail" as="a" role="menuitem" style={{ fontWeight: "bold" }}>
                            {l('Återförsäljare', 'Retailers')}
                        </Nav.Link>

                        <Nav.Link
                            as="button"
                            role="menuitem"
                            style={{ fontWeight: "bold", background: "none", border: "none", width: "100%", textAlign: "left" }}
                            onClick={() => toggleLanguage()}>
                            {language === "swe" ? <img src="https://flagcdn.com/gb.svg" alt="UK" width="40" /> : <img src="https://flagcdn.com/se.svg" alt="Sweden" width="40" />}
                        </Nav.Link>
                    </Nav>
                </div>
                <div
                    id="admin-dropdown-menu"
                    className={`dropdown-panel ${adminOpen ? "show" : ""}`}
                    role="menu"
                    aria-hidden={!adminOpen}
                >
                    <Nav
                        className="flex-column"
                        onSelect={() => setOpen("adminOpen", false)}
                    >
                        <Nav.Link href="/about" as="a" role="menuitem" style={{ fontWeight: "bold" }}>
                            Admin
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/editpage"
                            state={{ location: editPageType, section: section }}
                            role="menuitem"
                            style={{ fontWeight: "bold" }}
                        >
                            {l('Redigera sida', 'Edit page')}
                        </Nav.Link>
                        <Nav.Link
                            onClick={() => logout(setIsAuthenticated)}
                            as="a"
                            role="menuitem"
                            style={{ fontWeight: "bold" }}
                        >
                            {l('Logga ut', 'Log out')}
                        </Nav.Link>
                    </Nav>
                </div>
            </Navbar>
        </>
    );
};
